// it.js
const it = {
  // 公共
  common: {
    notSupport: 'Il vostro browser non supporta la modalità a schermo intero',
    loadFail: 'Caricamento del tema non riuscito',
    noPermission: 'Spiacente, non avete i permessi per accedere a tale pagina',
    backHome: 'Tornare alla pagina iniziale',
    noExit: 'La pagina a cui si state cercando di accedere non esiste',
    serverError: 'Spiacente, il server ha riscontrato un errore',
    slide: 'Scorrere il dito a destra',
    veryHigh: 'Molto Alto',
    high: 'Alto',
    target: 'Target',
    urgentLow: 'Molto Basso',
    agpNoData:
      'Il rapporto AGP richiede almeno 5 giorni di dati per essere generato.',
    noDataStr: 'Nessun Dato',
    setting: 'Impostazione',
    personInfo: 'Informazioni di Base',
    updatePwd: 'Cambiare la Password',
    upHead: 'Caricare le Immagini',
    inRange: "Nell'intervallo",
    normal: 'Normale',
    low: 'Basso',
    previous: 'Precedente',
    next: 'Successivo',
    search: 'Ricerca',
    reset: 'Resettare',
    cancel: 'Cancellare',
    ok: 'Ok',
    confirm: 'Confermare',
    save: 'Salvare',
    submit: 'Inviare',
    successful: 'Successo',
    pleaseEnter: 'Si prega di inserire',
    pleaseSelect: 'Si prega di selezionare',
    success: 'Successo',
    confirmLogout: 'Siete sicuri di volervi disconnettere?',
    updateSuccessed: 'Aggiornamento effettuato con successo',
    warning: 'Avvertimento',
    date: 'Data',
    start: 'Inizio',
    end: 'Fine',
    sevenDays: '7 Giorni',
    fourteenDays: '14 Giorni',
    thirtyDays: '30 Giorni',
    signOut: 'Uscire',
    personalInformation: 'Informazioni Personali',
    email: 'E-mail',
    name: 'Nome',
    mobile: 'Cellulare',
    dateOfBirth: 'Data di Nascita',
    gender: 'Genere',
    diabeteType: 'Tipi di Diabete',
    dateOfDignose: 'Anno della Diagnosi',
    remarks: 'Osservazioni',
    optionMale: 'Maschio',
    optionFemale: 'Femmina',
    optionUnknow: 'Preferire di Non Dichiarare',
    noDiabetes: 'Nessun Diabete',
    diabeteTypeI: 'Tipo I',
    diabeteTypeII: 'Tipo II',
    diabeteSpecial: 'Speciale',
    diabeteGestational: 'Gestazionale',
    diabeteOthers: 'Altri',
    ruleMsgEmail: "Si prega di inserire l'e-mail",
    ruleMsgName: 'Si prega di inserire il nome',
    ruleMsgMobile: 'Si prega di inserire il cellulare',
    ruleMsgBirthday: 'Si prega di selezionare il compleanno',
    ruleMsgSex: 'Si prega di selezionare il genere',
    ruleMsgDiabeteType: 'Si prega di selezionare il Tipo di diabete',
    ruleMsgDateOfDignose: "Si prega di selezionare l'anno di diagnosi",
    ruleMsgRemarks: 'Si prega di inserire le osservazioni',
    ruleMsgCorrectMobile: 'Si prega di inserire il corretto cellulare',
    oldPassword: 'Vecchia Password',
    newPassword: 'Nuova Password',
    confirmPassword: 'Confermare Password',
    ruleMsgOldPassword: 'Si prega di inserire la vecchia password',
    ruleMsgNewPassword: 'Si prega di inserire la nuova password',
    ruleMsgConfirmPassword: 'Si prega di confermare la password',
    passwordInconsistent: 'I due input di password non sono coerenti',
    passwordModifySuccessed:
      'La vostra password è stata reimpostata, si prega di accedere di nuovamente!',
    monday: 'Lunedi',
    tuesday: 'Martedi',
    wednesday: 'Mercoledi',
    thursday: 'Giovedi',
    friday: 'Venerdi',
    saturday: 'Sabato',
    sunday: 'Domenica',
    sn: 'SN',
    startDate: 'Data di Inizio',
    days: 'giorni',
    pdfDate: 'Obiettivo',
    close: 'chiudere',
    // inputTip: 'Si prega di inserire le parole chiave per la ricerca',
    inputTip: 'Si prega di inserire le paro...',
    polarization: 'Inizializzazione del dispositivo',
    hour: 'ora',
    minutes: 'minuti',
    seconds: 's',
    reportDownLoadTip: 'Il vostro rapporto non è stato generato per 5 giorni.',
    age: 'età',
    goal: 'Obiettivo',
    expired: 'sensore Scaduto',
    lastTime: "Ora dell'Utimo Aggiornamento",
    timeZone: 'Fuso orario'
  },
  // 路由
  route: {
    login: 'Accesso',
    forget: 'Dimenticare la Password',
    home: 'Home',
    glucoseReport: 'Rapporto sul Glucosio',
    sessionReport: 'Rapporto sulla Sessione',
    eventList: 'Elenco Eventi',
    followerList: 'Lista Follower',
    followerListQ: "Richiesta dell'Osservatore",
    settings: 'Impostazioni',
    profile: 'Profilo'
  },
  // 登录
  login: {
    rememberMe: 'Ricordarsi di me',
    forgetPassword: 'Dimenticare la password',
    agree: 'Accedere significa accettare FurCarer',
    privacyPolicy: 'Informativa sulla Privacy',
    CGMUser: 'Utente CGM',
    follower: 'Follower',
    ruleMsgPassword: 'Si prega di inserire la password',
    login: 'Accesso',
    phonePlacehold: 'Si prega di Inserire il numero di telefono',
    codePlacehold: 'Si prega di inserire il codice di verifica',
    codePlaceholdInput: 'Si pre...',
    phoneTip: 'Per Telefono',
    emialTip: 'Via E-mail',
    codeTip: 'Ottenere il codice di verifica',
    reGetTip: 'Riappropriazione'
  },
  // 布局
  layout: {
    collapseUp: 'Nascondere il Menu',
    collapseDown: 'Espandere il Menu',
    refresh: 'Aggiornare',
    backHome: 'Home',
    helpCenter: 'Centro Assistenza',
    fullScreen: 'Schermo Intero'
  },

  // 补充的翻译内容
  forget: {
    ruleMsgCode: 'Si prega di inserire il codice',
    sendCode: 'Inviare il Codice',
    tipsMsgSendSuccess: 'Il codice di verifica è stato inviato con successo!',
    tipsMsgModifySuccess: 'Modifica della password eseguita con successo'
  },
  home: {
    title: 'Portale FurCarer',
    todaysGlucose: 'Glucosio Oggi',
    todaysOverview: 'Panoramica Oggi',
    maxGlucose: 'Glucosio Massimo',
    minGlucose: 'Glucosio Minimo',
    avgGlucose: 'Media Glucosio',
    maxmumVariation: 'Variazione Massima',
    glucose: 'Glucosio',
    tir: 'TIR',
    latestGlucose: 'Ultimi dati sul Glucosio',
    todayPercentage: '% di Oggi in un intervallo diverso',
    fourHour: '4 Ore',
    eightHour: '8 Ore',
    twelveHour: '12 Ore',
    twentyFourHour: '24 Ore',
    glucoseOnly: 'Solo Glucosio',
    sessionOverview: 'Panoramica sulla Sessione',
    glocuseMetrics: 'Metriche del Glucosio',
    agp: 'AGP',
    dailyGlucose: 'Glucosio Giornaliero',
    sessionGlucose: 'Sessione Glucosio',
    standTir: 'TIR Standard',
    customTir: 'TIR Personalizzato',
    cancleGz: 'Non seguire',
    cancleText: "Si desidera non seguire l'utente corrente?",
    helpCenterTip: 'Funzione non ancora aperta'
  },
  glucoseReport: {
    statics: 'Statica',
    sixHour: 'TIR di 6 ore',
    avgGlucose: 'Media del Glucosio',
    maxGlucose: 'Glucosio Massimo',
    minGlucose: 'Glucosio Minimo',
    cv: 'CV',
    high: 'Numeri Grandi',
    low: 'Numeri Piccoli',
    normal: 'Numeri Normali',
    tir: 'TIR',
    estimatedA1c: 'A1c stimato',
    min: 'Minimo',
    avg: 'Media',
    max: 'Massimo',
    maxVariation: 'Variazione Massima'
  },
  glucoseProfile: {
    avg: 'Media',
    sd: 'SD',
    cv: 'CV'
  },
  eventList: {
    all: 'Tutti',
    bg: 'BG',
    meal: 'Pasto',
    sport: 'Sport',
    insulin: 'Insulina',
    alert: 'Allarme',
    eventType: 'Tipo di Evento',
    description: 'Descrizione',
    note: 'Nota',
    highAlert: 'avviso di allarme',
    calibration: 'Calibrazione',
    meds: 'Farmaci',
    time: 'Tempo',
    detail: 'Dettaglio',
    weigt: 'Peso'
  },
  followerList: {
    title: 'Monitoraggio degli Utenti',
    tabTitle: 'Gestione dei follower',
    refreshText:
      "Aggiornamento automatico (l'elenco degli utenti si aggiorna automaticamente ogni 30 secondi)",
    addText: 'Aggiungere',
    dataText: 'Dati ottenuti',
    timeText: 'minuti',
    hourText: 'ore',
    agoText: ' fa',
    tableEmail: 'Inserire il numero del conto',
    searchPlacehold: 'Inserire il numero del conto per effettuare la ricerca',
    pending: 'In attesa',
    approved: 'Approvato',
    rejected: 'Rifiutato',
    addFollower: 'Aggiungere Follower',
    editFollower: 'Modificare Follower',
    tableName: 'Nome',
    tableAddTime: 'Aggiungere Tempo',
    tableStatus: 'Status',
    tableApproved: 'Approvato',
    tableReject: 'Rifiutare',
    tableStartSharing: 'Iniziare la condivisione',
    tableStopSharing: 'Interrompere la condivisione',
    op: 'Operare',
    sharing: 'Condivisione',
    notSharing: 'Non condivisione',
    tableRemove: 'rimuovere',
    note: 'Nota',
    message: 'Messaggio',
    ruleMsgEmailEmpty:
      "Si prega di inserire l'e-mail per effettuare la ricerca",
    ruleMsgNote: 'Si prega di inserire la nota',
    ruleMsgMessage: 'Si prega di lasciare un messaggio',
    ruleMsgEmailCorrect: "Si prega di inserire l'e-mail corretta",
    formAcknowledge:
      "Sono consapevole che l'aggiunta di un follower consentirà a questo utente di vedere i miei dati.",
    sendFollowRequest: 'Inviare una richiesta di follow-up',
    setNote: 'Impostare Nota',
    tipsAcknowledge:
      "Si prega di selezionare la casella, l'utente riconosce che l'aggiunta di un follower consentirà al presente utente di vedere i miei dati",
    stopSharing: 'Interrompere la condivisione',
    startSharing: 'Iniziare la condivisione',
    removeUser: "Rimuovere l'Utente",
    confirmStopSharing:
      'Siete sicuri di non voler più condividere il glucosio con il presente utente?',
    confirmStartSharing:
      'Siete sicuri di voler iniziare a condividere il glucosio con il presente utente?',
    confirmRemove:
      "Siete sicuri di voler rimuovere il presente utente dall'elenco?",
    approvedFollower: 'Follower Approvato',
    rejectFollower: 'Rifiutare il Follower',
    confirmApproved:
      'Siete sicuri di poter approvare la presente richiesta di follower?',
    confirmReject:
      'Siete sicuri di voler rifiutare la presente richiesta di follower?',
    addTime: 'Aggiungere Tempo',
    check: 'Controllare',
    remove: 'Rimuovere',
    removeUserTitle:
      "Siete sicuri di voler rimuovere il presente utente dall'elenco?"
  },

  settings: {
    title: 'Impostazioni Livello Glucosio',
    unitSet: 'Impostazione Unità',
    targetSet: 'Impostazione Personalizzata TIR',
    alertSet: 'Impostazione Avvisi',
    highAlert: 'Allarme Elevato',
    lowAlert: 'Allarme Basso',
    urgentLow: 'Molto Basso',
    // urgentLow: 'Urgente Basso',
    urgentHigh: 'Urgente Alto',
    target: 'Target'
  },
  pdf: {
    dailyStatistics: 'Statistiche Giornaliere',
    title: 'Rapporto AGP: Monitoraggio Continuo del Glucosio',
    page: 'Pagina',
    generated: 'Generato',
    lage: 'LAGE',
    mage: 'MAGE',
    modd: 'MODD',
    range: "Tempo nell'Intervallo",
    timeInRange: "Tempo nell'Intervallo (TIR)",
    agpTitle: 'Profilo Glicemico Ambulatoriale (AGP)',
    agpSubTitle:
      'AGP è un riepilogo dei valori di glucosio del periodo di riferimento, con la mediana (50%) e gli altri percentili mostrati come se si fossero verificati in un unico giorno.',
    dailyTitle: 'Profilo Giornaliero Glucosio',
    dailySubTitle:
      'Ogni profilo giornaliero rappresenta un periodo da mezzanotte a mezzanotte.',
    device: 'Dispositivo',
    tDevice: 'Dispositivo Terminale',
    print: 'Stampare',
    model: 'Modello',
    deviceSn: 'Dispositivo SN',
    effectiveData: 'Dati Efficaci',
    days: 'Giorni',
    appVer: 'Versione App',
    smartPhoneModel: 'Modello Smartphone',
    osVersion: 'Versione OS',
    appSetting: 'Impostazione App',
    GoalsforType1andType2Diabetes:
      'Obiettivi per il Diabete di Tipo 1 e di Tipo 2',
    Each1timeinrange15minutes: "Ogni 1% di tempo nell'intervallo =~15 minuti",
    note: "Nota: L'unità % si riferisce allo standard DCCT, mentre l'unità mmol/mol si riferisce allo standard IFCC.",
    DOB: 'DOB',
    SN: 'SN'
  },
  field: {
    timeCgmActive: 'Tempo di Attivazione CGM',
    gmi: 'GMI',
    gri: 'GRI',
    eHbA1c: 'eHbA1c',
    avgPerDay: 'Calibrazione Media al Giorno',
    glucoseAbility: 'Variabilità del Glucosio',
    lage: 'Lage',
    mage: 'Mage',
    tar: 'TAR',
    tbr: 'TBR',
    calibrations: 'Tempi di Calibrazione'
  },
  agp: {
    agpTitle: 'Profilo Glicemico Ambulatoriale (AGP)',
    centerLine: 'Mediana',
    areaLine: 'Intervallo',
    target: 'Gamma di Obiettivi'
  },
  basic: {
    customTir: 'TIR personalizzato',
    bloodTip: 'Impostazioni del promemoria del glucosio',
    bloodUnit: 'Unità di Glucosio',
    highTip: 'Allarme Glucosio Alto',
    lowTip: 'Allarme Glucosio Basso',
    unitText: 'Impostazione automatica in base alla regione del paese',
    selectTip:
      "Fare clic sull'icona per selezionare o deselezionare la data corrispondente.",
    selectAll: 'Selezionare tutti'
  },
  report: {
    threeMonth: 'Ultimi 3 Mesi',
    sixMonth: 'Quasi 6 Mesi',
    yearText: 'Scorso anno',
    showAll: 'Mostrare tutti',
    all: 'Tutti',
    selectDate: 'Selezionare intervallo date',
    to: 'per',
    startDt: 'Data di Inizio',
    endDt: 'Data di Chiusura',
    betaTest: 'Test Beta',
    bloodData: 'Dati sul Glucosio',
    userCount: 'Account Utente'
  },
  petDetail: {
    variety: 'Razza',
    type: 'Tipo di Insulina',
    freq: 'Frequenza di Insulina',
    lente: 'Lente',
    insulin: 'Insulina Glargine',
    pzi: 'PZI',
    nph: 'NPH',
    detemir: 'Determir'
  },
  pdfReport: {
    title: 'Rapporto AGP',
    snNumber: 'SN',
    page: 'Pagina',
    createTime: 'Generato',
    petInfo: 'Informazioni sugli Animali Domestici',
    petName: 'Nome degli Animali Domestici',
    birthday: 'Data di Nascita',
    freq: 'Frequenza di Insulina',
    petType: 'Tipo di Animali Domestici',
    age: 'Età',
    registerType: 'Tipo di Siringa',
    basicBloodData: 'Metriche del Glucosio',
    dbText: "Tempo nell'intervallo（TIR）",
    target: 'Obiettivi per il Diabete di Tipo 1 e di Tipo 2',
    recordTime: 'Tempo di registrazione',
    tag: 'tag',
    event: 'Evento',
    eventDetail: "Dettagli dell'Evento",
    mulityText: "Grafico dell'andamento del glucosio su più giorni",
    mulitySubText:
      "I profili di glucosio plurigiornalieri rappresentano l'intervallo di tempo di un ciclo del dispositivo.",
    avageBlood: 'Media del Glucosio',
    bloodText: 'MODD',
    highTip: 'Allarme Glucosio Alto',
    lowTip: 'Allarme Glucosio Basso',
    cat: 'Gatto',
    dog: 'Cane',
    country: 'Paese',
    insulinDose: 'Dose di Insulina',
    weightUnit: 'kg'
  },
  eventDetail: {
  Empty: 'Colazione',
  After_Breakfast: 'Dopo la Colazione',
  Before_Lunch: 'Prima del Pranzo',
  Breakfast: 'Colazione',
  Lunch: 'Pranzo',
  Dinner: 'Cena',
  Before_Sleep: 'Prima del Sonno',
  Extra: 'Extra',
  Short_acting: "A breve durata d'azione",
  Pre_mixed: 'Premiscelato',
  Long_acting: "A lunga durata d'azione",
  Middle_acting: 'Recitazione media',
  hour: 'ore',
  minutes: 'minuti'
}
};

export default it;
